import React, { Component } from 'react';
import { Button, Select, DatePicker } from 'antd';
import SelectProvince from '../../common/SelectProvince';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = this.props;
        const { userName } = searchParams;
        this.state = {
            searchParams,
            isEdit: !!userName,
            render: true,
            positionList: [],
        }
    }

    componentDidMount() {
        this.queryPositinoByType();
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({...searchParams});
    }

    export = () => {
        this.props.export();
    }

    reset = () => {
        const { searchParams: { defaultMonth } } = this.state;
        this.setState({
            render: false,
            searchParams: {
                defaultMonth,
                startDate: defaultMonth,
                endDate: defaultMonth,
            }
        }, () => {
            this.setState({ render: true }, () => {
                this.search();
            })
        })
    }

    queryPositinoByType = () => {
        const options = {
            method: 'POST',
            url: API_URL.home.queryPositinoByType,
            data: { type: 'PERSONNEL_SUPERVISOR' },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({ positionList: data });
            }
        };
        $.sendRequest(options);
    }

    handleBeignMonth = (date, dateString) => {
        const { searchParams } = this.state;
        searchParams.startDate = dateString
        this.setState({ searchParams });
    }

    handleEndMonth = (date, dateString) => {
        const { searchParams } = this.state;
        searchParams.endDate = dateString
        this.setState({ searchParams });
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    disabledDate = (current) => {
        const { maxDate } = this.props;
        const value = moment(maxDate).add(1, 'M').valueOf();
        return current && current.valueOf() >= value;
    }

    handleChange = (option, key) => {
        const { searchParams } = this.state;
        const { text, value } = option;
        searchParams.userId = value;
        searchParams.userName = text;
        this.setState({ searchParams });
    }

    render () {
        const {
            render,
            positionList,
            searchParams: {
                startDate,
                endDate,
                positionName,
                userName,
                areaName,
                hasCheckedArea = [],
            }
        } = this.state;
        const begin = startDate ? moment(startDate) : null;
        const end = endDate ? moment(endDate) : null;
        const { positionRole } = sessionStorage;
        const positionOptions = positionList.map(i => <Option key={i.positionName}>{i.positionName}</Option>);
        return (
            <div className="filter-bar bar2" style={{ marginTop: 10 }}>
                <div className="form-item">
                    <label className="ui-label">时间</label>
                    <MonthPicker
                        format={monthFormat}
                        onChange={this.handleBeignMonth}
                        allowClear={false}
                        value={begin}
                        style={{width: 90}}
                        disabledDate={this.disabledDate}
                        className="w-90-select"
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">至</label>
                    <MonthPicker
                        format={monthFormat}
                        onChange={this.handleEndMonth}
                        allowClear={false}
                        value={end}
                        style={{width: 90}}
                        disabledDate={this.disabledDate}
                        className="w-90-select"
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">人员主管</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 156 }}
                        value={userName}
                        params={{ limit: 20 }}
                        placeholder="输入姓名/工号检索"
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={option => this.handleChange(option, 'userId')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">区域/城市</label>
                    { render && <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} /> }
                </div>
                <div className="form-item">
                    <label className="ui-label">职位级别</label>
                    <Select
                        allowClear={true}
                        value={positionName}
                        placeholder="请选择"
                        style={{ width: 120 }}
                        onChange={value => this.handleSelectChange(value, 'positionName')}
                    >
                        {positionOptions}
                    </Select>
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.reset}>重置</Button>
                    { positionRole !== 'CRC' && <Button type="primary" onClick={this.export}>导出</Button> }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/home/leaderPerformanceRank/Filter.js